import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Route-change scroll restoration.
 * Scrolls the window to the top on every pathname change so navigation
 * links (e.g. from the homepage nav to "How It Works") always land at
 * the top of the destination page.
 *
 * Preserves normal browser behavior for in-page anchor links: when the
 * URL contains a hash (#section), we skip the scroll-to-top and let the
 * browser jump to the anchor naturally.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default ScrollToTop;
